import { differenceInHours } from 'date-fns'

export default (date1: Date, date2: Date) => {
  const difference = differenceInHours(date1, date2)
  return difference < 0 ? difference * -1 : difference
}
